<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#FF618A"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false; type = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Bank Penerima
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider
               name="Nama" 
               rules="required" 
               v-slot="{ errors }">
                 <v-text-field
                  dense
                  outlined
                  label="Nama"
                  color="#ff618a"
                  v-model="form.bankName"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider
                name="Nomor Rekening" 
                rules="required" 
                v-slot="{ errors }">
               <v-text-field
                  dense
                  outlined
                  label="No Rekening"
                  color="#ff618a"
                  type="number"
                  v-model="form.bankAccountNumber"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
               <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'Draft', 
                      value: 'draft'
                    },
                    {
                      title: 'Publish', 
                      value: 'publish'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Status"
                  v-model="form.bankStatus"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
              <div class="mb-3">
                <p class="mb-1">Gambar</p>
                <form>
                  <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                          <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                             color="#ff618a"
                              indeterminate
                              rounded
                              height="6"
                              class="mx-4 mt-4"
                              style="width: 80px;">
                            </v-progress-linear>
                            <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                            </p>
                          </div>
                          <img v-if="avatar && !addImage"
                           :src="form.bankLogo" 
                           :alt="form.bankLogo" 
                            width="200"
                            height="200"/>
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.bankLogo">
                  {{ error.bankLogo }}
                </p>
              </div>
              <div>
                <v-alert
                  type="error"
                  text
                  dense
                  prominent
                  v-show="response !== ''">
                  {{ response }}
                </v-alert>
              </div>
              <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn
                  small
                  rounded
                  width="100"
                  color="#FF618A"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-btn
                  rounded
                  small
                  width="100"
                  elevation="0"
                  class="text-capitalize"
                  :disabled="process.form"
                  @click="reset(undefined, 'mobile'); selectedPage = 'create'; $refs.observer.reset()">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>
        <div v-if="selectedPage === 'detail'">
          <v-img :src="detail.bankLogo" width="100" height="100" class="mx-auto br-20"></v-img>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
               <p class="caption grey--text text-lighten-4 mb-1">
                Nama
              </p>
              {{detail.bankName}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Status
              </p>
              {{detail.bankStatus}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nomor Rekening
              </p>
              {{detail.bankAccountNumber}}
            </v-list-item-title>
          </div>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="100"
              elevation="0"
              class="text-capitalize"
              @click="reset(undefined, 'mobile'); selectedPage = 'detail'">
              Tutup
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense
            :hide-details="true"
            placeholder="Cari bank penerima . . ."
            v-model="filter.title"
            clearable
            color="#ff618a"
            @click:clear="filter.title = ''; fetch();showPage = false"
            v-on:keyup.enter="fetch(); showPage = false"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn
            :color="!showPage ? '#FF618A' : '#F5F5F5'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            :dark="!showPage"
            elevation="0"
            rounded
            :light="showPage"
            :disabled="process.form"
            v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(undefined, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(undefined, 'mobile') : reset()"
            @click="selectedPage = 'create';">
            <span v-if="!showPage">Tambah Bank Penerima</span>
            <span v-if="showPage">Kembali</span>
          </v-btn>
        </div>

        <div class="my-5">
          <div class="title text--secondary">Data Bank Penerima</div>
          <div class="caption text--secondary">{{pagination.totalData}} Bank Penerima Ditemukan</div>
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                <v-list-item-avatar 
                  tile 
                  @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer" style="box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3) !important;">
                  <v-img :src="l.bankLogo" style="border-radius: 5px;"></v-img>
                </v-list-item-avatar>
                <v-list-item-content 
                  @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" 
                  class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2">
                    {{ l.bankName }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin"
                    v-if="$vuetify.breakpoint.name !== 'xs'">
                    {{l.bankStatus}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="ml-3 text-right">
                  <div>
                    <v-btn
                      fab
                      x-small
                      :disabled="process.form"
                      color="#269B91"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(l, 'mobile') : reset(l)"
                      @click="selectedPage = 'update'">
                      <v-icon small>mdi-square-edit-outline</v-icon>
                    </v-btn>
                    <v-btn 
                      fab
                      x-small
                      :disabled="process.form"
                      color="red"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      @click="form.bankId=l.id; dialog.delete=true">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Bank Penerima"/>

          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2 font-weight-bold mt-4">Total {{ pagination.totalData }} data</div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#FF618A"
                    @input="fetch(page);showPage = false"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Bank Penerima
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama"
                  color="#ff618a"
                  v-model="form.bankName"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Nomor Rekening" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nomor Rekening"
                  color="#ff618a"
                  type="number"
                  v-model="form.bankAccountNumber"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'Draft', 
                      value: 'draft'
                    },
                    {
                      title: 'Publish', 
                      value: 'publish'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Status"
                  v-model="form.bankStatus"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
              <div class="mb-3">
                <p class="mb-1">Gambar</p>
                <form>
                   <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                          <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                              color="#ff618a"
                              indeterminate
                              rounded
                              height="6"
                              class="mx-4 mt-4"
                              style="width: 80px;">
                            </v-progress-linear>
                            <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                            </p>
                          </div>
                          <img v-if="avatar && !addImage"
                           :src="form.bankLogo" 
                           :alt="form.bankLogo" 
                            width="200"
                            height="200"/>
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.bankLogo">
                  {{ error.bankLogo }}
                </p>
              </div>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
              </div>
              <v-card-actions class="mt-3">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  light
                  width="200"
                  color="#FF618A"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>
        
        <div v-if="selectedPage === 'detail'">
          <v-img :src="detail.bankLogo" width="100" height="100" class="mx-auto br-20"></v-img>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nama
              </p>
              {{detail.bankName}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Status
              </p>
              {{detail.bankStatus}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nomor Rekening
              </p>
              {{detail.bankAccountNumber}}
            </v-list-item-title>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import ImageInput from "../../../../components/ImageInput.vue";
  import Empty from "../../../../components/DataEmpty";
  export default {
    data() {
      return {
        showPage: false,
        selectedPage: "",
        filter: {
          title: ""
        },
        dialog: {
          delete: false,
          form: false
        },
        addImage:'',
        detail: {},
        list: [],
        pagination: {},
        page: 1,
        avatar: "",
        form: {
          bankId: "",
          bankName: "",
          bankAccountNumber: "",
          bankStatus: "draft",
          bankLogo: ""
        },
        error: {
          bankLogo: ""
        },
        process: {
          form: false,
          run: false
        },
        response: ""
      };
    },
    watch: {
      avatar: {
        handler: function () {
          this.form.bankLogo = this.avatar ? this.avatar.url : ""
          this.addImage = this.avatar.add
          this.error.bankLogo = ''
        },
        deep: true
      }
    },
    components: {
      ImageInput,
      Empty
    },
    computed: {},
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true;
        await get(`api/internal/bank/list`, {
            params: {
              pagenum: p,
              limit: 10,
              title: this.filter.title
            }
          })
        .then(response => {
          let res = response.data;
          if (res.code === 200) {
            this.process.run = false;
            this.list = res.data;
            this.pagination = res.pagination;
          }
        });
      },
      toDetail(item, status) {
        this.detail = item
        this.selectedPage = "detail"
        this.showPage = status !== undefined ? false : true
        this.dialog.form = status !== undefined ? true : false
      },
      reset(item, status) {
        this.showPage = status !== undefined ? false : !this.showPage ? true : false

        this.avatar = item !== undefined ? {
          url: item.bankLogo
        } : ''

        this.addImage = item !== undefined ? false : ""

        this.form = {
          bankId: item !== undefined ? item.id : "",
          bankName : item !== undefined ? item.bankName : "",
          bankAccountNumber: item !== undefined ? item.bankAccountNumber : "",
          bankStatus: item !== undefined ? item.bankStatus : "",
          bankLogo: item !== undefined ? item.bankLogo : ""
        }
        this.dialog.form = status !== undefined ? !this.dialog.form ? true : false : false

        this.selectedPage = ''
        this.process.form = false

        this.error = {
          bankLogo: ""
        }

        this.response = ''
      },
      async save() {
        this.response = "";
        const valids = this.validation();
        const isValid = await this.$refs.observer.validate();
        if (isValid && valids) {
          if (this.form.bankId === "") {
            this.creates();
          } else {
            this.updates();
          }
        }
      },
      validation() {
        var error = this.error,
          valid = true;

        if (this.form.bankLogo === "") {
          error.bankLogo = "Gambar tidak boleh kosong";
          valid = false;
        } else {
          error.bankLogo = "";
        }

        return valid;
      },
      async creates() {
        this.process.form = true;
        await post(`api/internal/bank/create`, {
          data: {
            bankName: this.form.bankName,
            bankAccountNumber: this.form.bankAccountNumber,
            bankStatus: this.form.bankStatus,
            bankLogo: this.form.bankLogo,
          }
        }).then(response => {
          let res = response.data;
          if (res.code == 201) {
            this.fetch();
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async updates() {
        this.process.form = true;
        await put(`api/internal/bank/update/${this.form.bankId}`, {
          data: {
            id: this.form.bankId,
            bankName: this.form.bankName,
            bankAccountNumber: this.form.bankAccountNumber,
            bankStatus: this.form.bankStatus,
            bankLogo: this.form.bankLogo
          }
        }).then(response => {
          let res = response.data;
          if (res.code === 201) {
             this.fetch(this.page);
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async deletes(){
         this.process.form = true;
         await destroy(`api/internal/bank/delete/${this.form.bankId}`).then((response) => {
           let res = response.data;
           if(res.code == 201){
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.fetch()
           }else{
            this.process.form = false
            this.response = res.msg
           }
         })
      }
    }
  };
</script>

<style scoped>
.br-20 {
  border-radius: 20px;
}
</style>

